import { IconComponent } from './types';

const RoadsIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_615_6402"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="12"
      height="12"
    >
      <rect y="4.76837e-07" width="12" height="12" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_615_6402)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1568 3.00876L-4 3L-3.99939 2.5L14.1575 2.50876L14.1568 3.00876Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1568 10.51L-4 10.5L-3.99947 10L14.1574 10.01L14.1568 10.51Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7H0V6H12V7Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default RoadsIcon;
